<template>
  <section v-if="uris.length" class="container mx-auto lg:grid lg:grid-cols-12 gap-x-8 v-page-section-container-padding">
    <h2
      v-if="title"
      class="col-span-full xl:col-start-2 xl:col-end-12 font-semibold leading-tight text-2xl md:text-3xl mb-4 md:mb-6"
      :class="{
        'text-white': colorTheme === 'dark-green' || colorTheme === 'petrol' || colorTheme === 'red',
        'text-app-primary-1-red--torch': colorTheme === 'blue' || colorTheme === 'light-green',
        'text-app-primary-1-red--fire-brick': colorTheme === 'pink',
      }"
    >
      {{ title }}
    </h2>
    <ul class="col-span-full xl:col-start-2 xl:col-end-12">
      <li v-for="uri in uris" :key="uri" class="mb-6">
        <OrganismLoaderFromUri :uri="uri">
          <template #loading>
            <MoleculeCardEventAndSeries :loading="true" />
          </template>
          <template #default="event">
            <MoleculeCardEventAndSeries
              :end-date="event.eventEndDate ? new Date(event.eventEndDate) : undefined"
              :event-id="event.iConcertId"
              :image="get(event, 'production.teaserImage')"
              :location="get(event, 'room.title')"
              :title="get(event, 'production.title')"
              :tix-pricing="{ minPrice: event.minPrice }"
              :tix-sale="prepareTixSale(event)"
              :url="event.url"
              :when="new Date(event.eventDate)"
              :works="get(event, 'production.works')"
            />
          </template>
        </OrganismLoaderFromUri>
      </li>
    </ul>
    <div class="col-span-full xl:col-start-2 xl:col-end-12 md:pt-3">
      <MoleculeButton v-if="buttonUrl && buttonLabel" :url="buttonUrl">{{ buttonLabel }}</MoleculeButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import get from 'lodash/get'

defineProps({
  uris: { type: Array as PropType<any[]>, required: true },
  title: { type: String, required: false, default: undefined },
  buttonLabel: { type: String, required: false, default: undefined },
  buttonUrl: { type: String, required: false, default: undefined },
  colorTheme: { type: String, required: false, default: undefined },
})

const prepareTixSale = setupPrepareTixSale()
</script>
